import React from "react";
import "./VisitItem.sass"
import PropTypes from "prop-types";
import CheckIcon from '@mui/icons-material/Check';
import HMobiledataIcon from '@mui/icons-material/HMobiledata';
import {useSelector} from "react-redux";

export default function VisitItem({visit, editable, onClick, isCanceled}) {

    const {data} = useSelector(state => state.groups.selected)

    const getValue = () => {
        if (visit.isVisited === false) {
            return <HMobiledataIcon/>
        } else if (visit.isVisited === true) {
            return <CheckIcon/>
        }
    }

    const isNext = () => {
        if (visit && data && data.lesson) {
            const {lesson} = data;
            return lesson.date === visit.lesson.date
        }
    }

    return (
        <div className={"VisitItem-wrapper " + (isNext() ? "VisitItem-current" : "") + (isCanceled ? "VisitItem-canceled" : "")}
             onClick={editable ? onClick : () => {}}>
            {
                visit && <div className={"VisitItem-checkbox " + (editable ? "VisitItem-editable" : "VisitItem-blocked")}>
                    {getValue()}
                </div>
            }
        </div>
    )
}

VisitItem.propTypes = {
    visit: PropTypes.object,
    editable: PropTypes.bool,
    onClick: PropTypes.func,
    isCanceled: PropTypes.bool,
}